import { render, staticRenderFns } from "./MiningOverview.vue?vue&type=template&id=315e5f50&scoped=true"
import script from "./MiningOverview.vue?vue&type=script&lang=js"
export * from "./MiningOverview.vue?vue&type=script&lang=js"
import style0 from "./MiningOverview.vue?vue&type=style&index=0&id=315e5f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e5f50",
  null
  
)

export default component.exports